import { render } from "./PopupDelete.vue?vue&type=template&id=2d091314&scoped=true"
import script from "./PopupDelete.vue?vue&type=script&lang=js"
export * from "./PopupDelete.vue?vue&type=script&lang=js"

import "./PopupDelete.vue?vue&type=style&index=0&id=2d091314&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d091314"

export default script